/**
 * video-slideshow
 */

import $ from 'jquery';
import 'slick-carousel/slick/slick';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import 'slick-lightbox/dist/slick-lightbox';
import 'slick-lightbox/dist/slick-lightbox.css';
import 'slick-carousel/slick/fonts/slick.eot';
import 'slick-carousel/slick/fonts/slick.svg';
import 'slick-carousel/slick/fonts/slick.ttf';
import 'slick-carousel/slick/fonts/slick.woff';

// Module dependencies
import 'protons';

// Module styles
import './_video-slideshow.scss';

// Module template
import './_video-slideshow.twig';

export const name = 'videoSlideshow';

export const defaults = {
  dummyClass: 'js-video-slideshow-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { videoSlideshow = {} }) {
  // Find our component within the DOM
  const $gallery = $('.video-slideshow', $context);
  // Bail if component does not exist

  if (!$gallery.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...videoSlideshow,
  };
  // An example of what could be done with this component
  $gallery.addClass(settings.dummyClass);
}

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
  if (player == null || command == null) {
    return;
  }
  player.contentWindow.postMessage(JSON.stringify(command), '*');
}

// When the slide is changing
function playPauseVideo(_slick, control) {
  let video;
  const currentSlide = _slick.find('.slick-current');
  const slideType = currentSlide.find('.item').attr('class').split(' ')[1];
  const player = currentSlide.find('iframe').get(0);
  const startTime = currentSlide.data('video-start');

  if (slideType === 'vimeo') {
    switch (control) {
      case 'play':
        if (
          startTime != null &&
          startTime > 0 &&
          !currentSlide.hasClass('started')
        ) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            method: 'setCurrentTime',
            value: startTime,
          });
        }
        postMessageToPlayer(player, {
          method: 'play',
          value: 1,
        });
        break;
      case 'pause':
        postMessageToPlayer(player, {
          method: 'pause',
          value: 1,
        });
        break;
      default:
        break;
    }
  } else if (slideType === 'youtube') {
    switch (control) {
      case 'play':
        postMessageToPlayer(player, {
          event: 'command',
          func: 'mute',
        });
        postMessageToPlayer(player, {
          event: 'command',
          func: 'playVideo',
        });
        break;
      case 'pause':
        postMessageToPlayer(player, {
          event: 'command',
          func: 'pauseVideo',
        });
        break;
      default:
        break;
    }
  } else if (slideType === 'video') {
    video = currentSlide.find('video').get(0);
    if (video != null) {
      if (control === 'play') {
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

$(document).ready(() => {
  if ($.fn.modaal !== undefined && $('.youtube-modal').length) {
    $('.youtube-modal').modaal({
      type: 'video',
    });
  }
  const $carousel = $('.video-slideshow');

  if ($carousel.length && $.fn.slick) {
    // DOM Ready
    const mainSliderSettings = {
      autoplaySpeed: 4000,
      lazyLoad: 'progressive',
      speed: 600,
      arrows: false,
      dots: false,
      cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)',
    };
    const navSliderSettings = {
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      focusOnSelect: true,
    };
    const responsiveGallery = [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 11,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
    ];
    let $currentSlider = {};
    let $currentNav = {};

    try {
      $carousel.each((ind) => {
        if ($carousel.length > 0 && $carousel.eq(ind) !== undefined) {
          const slideWrapper = $carousel.eq(ind).find('.main-slider');
          const slideNav = $carousel.eq(ind).find('.slider-nav');
          const lazyImages = slideWrapper.find('.slide-image');
          let lazyCounter = 0;

          // Initialize
          slideWrapper.on('init', (_slick) => {
            const slick = $(_slick.currentTarget);
            setTimeout(() => {
              playPauseVideo(slick, 'play');
            }, 1000);
          });
          slideWrapper.on('beforeChange', (event, _slick) => {
            const slick = $(_slick.$slider);
            playPauseVideo(slick, 'pause');
          });
          slideWrapper.on('afterChange', (event, _slick) => {
            const slick = $(_slick.$slider);
            playPauseVideo(slick, 'play');
          });
          slideWrapper.on('lazyLoaded', () => {
            lazyCounter += 1;
            if (lazyCounter === lazyImages.length) {
              lazyImages.addClass('show');
            }
          });

          for (let i = 0; i < slideWrapper.length; i += 1) {
            $currentSlider = $(slideWrapper[i]);
            $currentNav = slideNav.eq(i);

            mainSliderSettings.asNavFor = $currentNav;
            navSliderSettings.asNavFor = $currentSlider;

            if ($currentSlider.hasClass('gallery')) {
              navSliderSettings.slidesToShow = 14;
              navSliderSettings.responsive = responsiveGallery;
            } else {
              navSliderSettings.slidesToShow = 3;
            }

            try {
              $currentSlider
                .not('.slick-initialized')
                .slick(mainSliderSettings);
              $currentNav.not('.slick-initialized').slick(navSliderSettings);
              $currentSlider.slickLightbox({
                itemSelector: 'a',
                navigateByKeyboard: true,
                caption: 'caption',
              });
            } catch (e) {
              console.log('Single Slidehow error:');
              console.log(e);
            }
          }

          // Re-initialize Blazy on media slides as it was hidden from view:
          const $src = $(document).find(
            '.video-slideshow .b-lazy:not(.b-loaded)'
          );
          Drupal.blazy.init.load($src, true);
        }
      });
    } catch (e) {
      console.log('Video Slidehow error:');
      console.log(e);
    }
  }
});

export default enable;
